/**
 * Bridge for capturing the globe's WebGL canvas.
 * Uses window as the shared namespace to avoid module-instance
 * issues with Next.js dynamic imports.
 *
 * GlobeVisualization registers a capture function on mount;
 * page.tsx calls captureGlobeScreenshot() to get a data URL.
 */

declare global {
  interface Window {
    __captureGlobe?: () => string | null;
  }
}

export function registerGlobeCapture(fn: (() => string | null) | null) {
  if (fn) {
    window.__captureGlobe = fn;
  } else {
    delete window.__captureGlobe;
  }
}

export function captureGlobeScreenshot(): string | null {
  return window.__captureGlobe?.() ?? null;
}
